import React from "react";
import { Props } from "./types";

function SubordinatesIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 20 16">
      <path d="M14.5,8a3,3,0,1,0-3-3A3,3,0,0,0,14.5,8Zm-9,0a3,3,0,1,0-3-3A3,3,0,0,0,5.5,8Zm0,2c-2.33,0-7,1.17-7,3.5V16h14V13.5C12.5,11.17,7.83,10,5.5,10Zm9,0c-.29,0-.62.02-.97.05A4.22,4.22,0,0,1,15.5,13.5V16H21V13.5C21,11.17,16.33,10,14.5,10Z" />
    </svg>
  );
}

export { SubordinatesIcon };
